import { env } from "../cfg/env";

const userActions = {
  fetchUserInfo: "fetchUserInfo",
  updateUserInfo: "updateUserInfo",
  sendMfaCode: "sendMfaCode",
  sendTotpInfo: "sendTotpInfo",
  verifyMfaCode: "verifyMfaCode",
  getAppIds: "getAppIds",
  totpInitCall: "totpInitCall",
  verifyTotpCode: "verifyTotpCode",
  resetTotp: "resetTotp",
  auditLog: "auditLog",
  isMd2Lite: "isMd2Lite",
  isObSetup: "isObSetup",
  authorizeClient: "authorizeClient",
  authToken: "authToken",
  middlewareLogout: "middlewareLogout",
  ssoSessionCheck: "ssoSessionCheck",
  disableMFA:"disableMFA",
  // QBO Accounting actions
  getUIConnections: "getUIConnections",
  deleteConnection: "deleteConnection",
  qboAcceptTerms: "qboAcceptTerms",
  accountingFeatureFlag: "accountingFeatureFlag",
  accountingConnectionCreate: "accountingConnectionCreate",
  qboConnectionEligibility: "qboConnectionEligibility",
  analyticsTrace: "analyticsTrace",
  planSelect: "planSelect",
  changePlan: "changePlan",
  cancelSubscription: "cancelSubscription",
};

const funcName = `${env.sso.functionDomain}`;
const authClientDomain = env.sso.authClientDomain;
const masFunctionUrl = env.sso.masFunctionUrl;

const apiList = {
  [userActions.fetchUserInfo]: `https://${funcName}/auth/api/b2c-user-info`,
  [userActions.updateUserInfo]: `https://${funcName}/auth/api/b2c-user-info-update`,
  [userActions.sendMfaCode]: `https://${funcName}/auth/api/b2c-mfa-code-send`,
  [userActions.sendTotpInfo]: `https://${funcName}/auth/api/b2c-mfa-totp-setup`,
  [userActions.verifyTotpCode]: `https://${funcName}/auth/api/b2c-mfa-totp-verify`,
  [userActions.totpInitCall]: `https://${funcName}/auth/api/b2c-mfa-totp-init`,
  [userActions.verifyMfaCode]: `https://${funcName}/auth/api/b2c-mfa-code-verify`,
  [userActions.resetTotp]: `https://${funcName}/auth/api/b2c-mfa-totp-reset`,
  [userActions.auditLog]: `https://${funcName}/auth/api/b2c-log-audit-event`,
  [userActions.isMd2Lite]: `https://${funcName}/auth/api/md2-is-applicant`,
  [userActions.isObSetup]: `https://${funcName}/auth/api/md2-redirect-eligibility`,
  [userActions.authorizeClient]: `https://${authClientDomain}/B2C_1A_SIGNUP_SIGNIN/oauth2/v2.0/authorize`,
  [userActions.authToken]: `https://${funcName}/auth/token`,
  [userActions.middlewareLogout]: `https://${funcName}/auth/logout`,
  [userActions.disableMFA]: `https://${funcName}/auth/api/b2c-user-disable-mfa`,
  // QBO Accounting endpoints
  [userActions.getUIConnections]: `${masFunctionUrl}/ui/connection?api-version=v1`,
  [userActions.deleteConnection]: `${masFunctionUrl}/ui/connection/self/delete?api-version=v1`,
  [userActions.qboAcceptTerms]: `${masFunctionUrl}/ui/terms/self?api-version=v1`,
  [userActions.accountingFeatureFlag]: `${masFunctionUrl}/ui/accounting-ff?api-version=v1`,
  [userActions.accountingConnectionCreate]: `${masFunctionUrl}/ui/connection/self/create?api-version=v1`,
  [userActions.qboConnectionEligibility]: `${masFunctionUrl}/ui/connection/eligibility?api-version=v1`,
  [userActions.analyticsTrace]: `${masFunctionUrl}/ui/analytics/trace?api-version=v1`,
  [userActions.planSelect]: `${masFunctionUrl}/ui/subscription/self/plan-select?api-version=v1`,
  [userActions.changePlan]: `${masFunctionUrl}/ui/subscription/self/change-plan?api-version=v1`,
  [userActions.cancelSubscription]: `${masFunctionUrl}/ui/subscription/self/cancel?api-version=v1`,
};

const clinetIds = {
  mogo: {
    dev: "77192686-ed8b-47b9-9682-066ff527ca74",
    qa: "02042f00-525c-4336-b232-e4a10d333ffb",
    prod: "c0e17c8f-73d9-4d5f-b308-424fee35143d",
  },
};

const methodType = {
  get: "GET",
  post: "POST",
  patch: "PATCH",
  delete: "DELETE",
};

export { userActions, apiList, methodType, clinetIds };
